export default "__VITE_ASSET__B5SuNZ91__"